module.exports = __webpack_public_path__ + "static/img/brand.9d63bb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brand.png
// module id = bUR8
// module chunks = 0